import { WAVEFORM_CACHE_VERSION } from "../waveform/types";

export function fileFingerprint(
  file: File,
  sampleRate: number,
  durationFrames: number,
): string {
  return [
    WAVEFORM_CACHE_VERSION,
    file.name,
    file.size,
    file.lastModified,
    sampleRate,
    durationFrames,
  ].join(":");
}
